import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box, IconButton, Typography } from '@mui/material';
import { QueryKey } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Logbook } from '../types/listTypes';
import DeleteLogbookModal from './DeleteLogbookModal';

interface LogbookActionsProps {
    row: Logbook;
    queryKey: QueryKey;
    onEditHover?: (row: Logbook) => void;
    canEdit: boolean;
    canDelete: boolean;
}

export default function LogbookActions({ row, queryKey, onEditHover, canEdit, canDelete }: LogbookActionsProps) {
    const { t } = useTranslation();
    const [openDelete, setOpenDelete] = useState(false);
    const handleDelete = () => {
        setOpenDelete(true);
    };

    return (
        <Box display="flex" alignItems="center" justifyContent='center'>
            {canEdit && (
            <Link
                to={`logbook-configuration/${row.id}`}
                aria-label={t('logbookConfig.configureLogbook', 'Configure {{name}}', { name: row.logbookTemplateName })}
                onMouseEnter={onEditHover ? () => onEditHover(row) : undefined}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                    color: 'inherit'
                }}
            >
                <LaunchIcon fontSize="small" color='primary' sx={{ mr: 1 }} />
                {t('logbookConfig.configure', 'Configure')}
            </Link>
            )}
            {canEdit && canDelete && <Typography aria-hidden="true" sx={{ p: 1, color: 'Primary.main', opacity: 0.7 }}>•</Typography>}
            {canDelete && (
                <IconButton onClick={handleDelete} aria-label={t('logbookConfig.deleteLogbook', 'Delete {{name}}', { name: row.logbookTemplateName })}>
                    <DeleteOutlineIcon fontSize="small" />
                </IconButton>
            )}
            {openDelete && (
                <DeleteLogbookModal
                    handleClose={() => setOpenDelete(false)}
                    data={row}
                    queryKey={queryKey}
                />
            )}
        </Box>
    );
}